var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15536 4.62346H5.84578C5.99172 4.62346 6.10906 4.50564 6.10906 4.3597C6.10906 4.21425 5.99172 4.09595 5.84578 4.09595H2.15536C2.00942 4.09595 1.8916 4.21425 1.8916 4.3597C1.8916 4.50564 2.00942 4.62346 2.15536 4.62346Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15536 5.67815H5.84578C5.99172 5.67815 6.10906 5.55985 6.10906 5.41439C6.10906 5.26894 5.99172 5.15063 5.84578 5.15063H2.15536C2.00942 5.15063 1.8916 5.26894 1.8916 5.41439C1.8916 5.55985 2.00942 5.67815 2.15536 5.67815Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30752 0.588593C6.93685 1.39441 7.21952 1.76168 7.64279 2.32435C7.83043 2.57308 7.87867 2.91878 7.87867 3.3149V6.31805C7.87867 6.93914 7.37031 7.44774 6.74897 7.44774H1.25079C0.629215 7.44774 0.121094 6.93938 0.121094 6.31805V1.19684C0.121094 0.575502 0.629215 0.0671387 1.25079 0.0671387H1.34509V1.64871H5.09152V0.0678659C5.50437 0.0702902 5.98752 0.179139 6.30752 0.588593ZM1.36352 6.31829H6.63576V3.45623H1.36352V6.31829Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32227,
    y: 0.0671387,
    width: 1.27079,
    height: 1.18642
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default ForwardRef;